import { render, staticRenderFns } from "./EnterDetails.vue?vue&type=template&id=5bcd74c0&scoped=true"
import script from "./EnterDetails.vue?vue&type=script&lang=js"
export * from "./EnterDetails.vue?vue&type=script&lang=js"
import style0 from "./EnterDetails.vue?vue&type=style&index=0&id=5bcd74c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd74c0",
  null
  
)

export default component.exports